import React from "react";
import { useParams } from "react-router-dom";
import { SectionUnlockingSwitch } from "features/AdminPanel/modules/SectionUnlockingSwitch/SectionUnlockingSwitch";
import { ManageVariationsButton } from "./modules/ManageVariationsButton/ManageVariationsButton";
import { useOfferingVariationListStore } from "features/OfferingVariations/pages/OfferingVariationsList/store/useOfferingVariationList.store";
import { useOfferingVariations } from "features/OfferingVariations/utils/hooks/useOfferingVariations";

export const ManageVariationsSwitch = () => {
  const { listing_uuid: offeringUuid } = useParams();
  const { provider } = useOfferingVariations({ offeringUuid });
  const { getListingDetails, onEnableVariationSwitchChange } = provider;
  const isEnabled = useOfferingVariationListStore((state) => state.isEnabled);
  const offeringDetails = useOfferingVariationListStore(
    (state) => state.offeringDetails
  );

  React.useEffect(() => {
    getListingDetails();
  }, []);

  return (
    <div className="tw-flex tw-items-center tw-gap-[30px]">
      <SectionUnlockingSwitch
        value={isEnabled}
        onChange={onEnableVariationSwitchChange}
      />
      {isEnabled && (
        <ManageVariationsButton offeringType={offeringDetails?.type} />
      )}
    </div>
  );
};
